export const domainURL = 'correios' // correios
// export const domainURL = 'localhost:3000' // localhost:3000

export const getSubDomain = window.location.href.split('/')[2].split('.')

export const verAccessType = (data: string[]): boolean => {
  const accessType = data.some((item) => item === domainURL)
  return accessType
}
